import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { apiFetch } from "../../api";
import VehiculosDashboard from "../components/VehiculosDashboard";

export default function VehiculosDatosContainer({ desde, hasta }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!desde || !hasta) return;
    let alive = true;
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const params = new URLSearchParams({ desde, hasta });
        const res = await apiFetch(`/api/datos/vehiculos/?${params.toString()}`, { credentials: "include" });
        if (!res.ok) {
          const detail = await res.json().catch(() => ({}));
          throw new Error(detail.detail || `HTTP ${res.status}`);
        }
        const payload = await res.json();
        if (alive) setData(payload);
      } catch (e) {
        if (alive) setError(e.message || "No se pudieron cargar los datos de vehículos.");
      } finally {
        if (alive) setLoading(false);
      }
    };
    fetchData();
    return () => {
      alive = false;
    };
  }, [desde, hasta]);

  if (loading && !data) {
    return (
      <Box sx={{ minHeight: 420, display: "grid", placeItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error" sx={{ borderRadius: "8px" }}>{error}</Alert>;
  }

  if (!data) return null;

  return <VehiculosDashboard data={data} />;
}
